import { API, graphqlOperation } from "aws-amplify";
export default class CompanySurvey {
  constructor(filter) {
    this._filter = filter;
    this._nextToken = null;
    this._graphData = null;
  }

  getGraphData() {
    const that = this;
    return new Promise(async function(resolve) {
      let results = await that.getCompanySurveyData();
      that._graphData = results;
      while (that._nextToken !== null) {
        let nextResultSet = await that.getCompanySurveyData();
        that._graphData.push(...nextResultSet);
      }
      resolve(that._graphData);
    });
  }

  async getCompanySurveyData() {
    const listSurveyCompany2022s = /* GraphQL */ `
      query ListSurveyCompany2022s(
        $filter: ModelSurveyCompany2022FilterInput
        $limit: Int
        $nextToken: String
      ) {
        listSurveyCompany2022s(
          filter: $filter
          limit: $limit
          nextToken: $nextToken
        ) {
          items {
            id
            surveyId
            companyName
            event
            communication
            impact
            performance
            valueformoney
            participants
            type
            feedback
            createdAt
            updatedAt
          }
          nextToken
        }
      }
    `;

    let gqlConfig = {
      nextToken: this._nextToken,
      limit: 2000
    };
    if (this._filter) {
      gqlConfig = {
        filter: this._filter,
        nextToken: this._nextToken,
        limit: 2000
      };
    }

    const {
      data: { listSurveyCompany2022s: results }
    } = await API.graphql(graphqlOperation(listSurveyCompany2022s, gqlConfig));
    this._nextToken = results.nextToken;
    return results.items;
  }

  getUniqueCompanyNames() {
    const uniqueColumn = this._graphData.map(function(value) {
      return value.companyName.trim();
    });
    let uniqueArray = [...new Set(uniqueColumn)];
    return uniqueArray.sort();
  }

  getUniqueParticipants() {
    const participantRows = this._graphData.map(function(result) {
      return result.participants.trim().split(",");
    });

    let resultPerParticipant = [];
    participantRows.forEach(row => {
      row.forEach(participant => {
        if (participant) {
          resultPerParticipant.push(participant.trim().toLowerCase());
        }
      });
    });
    let uniqueArray = [...new Set(resultPerParticipant)];
    return uniqueArray.sort();
  }
}
